import React, { Component } from 'react';
import axios from 'axios';
const labels = {OK:'Đang hoạt động', NOT_FOUND:'Không tồn tại', DELETED:'Đã xóa', INACTIVE:'Không đủ điều kiện', AMBIGUOUS:'UID không xác định duy nhất', INVALID_FORMAT:'UID không hợp lệ', LIVE_ROOM_CHANGED:'UID đã chuyển sang phòng khác'};

export default class LiveRoomGiftFields extends Component {
    state = { input: '', results: [], loading: false, error: '' };
    sequence = 0;
    componentWillUnmount() { clearTimeout(this.timer); this.sequence += 1; }
    lookup = async (input) => {
        const sequence = ++this.sequence;
        const tokens = Array.from(new Set(input.trim().split(/[,;\s]+/).filter(Boolean)));
        if (!tokens.length) { this.setState({ results: [], loading: false, error: '' }); return []; }
        if (tokens.length > 100) { this.setState({ loading: false, error: 'Mỗi lần tra tối đa 100 UID.' }); return []; }
        this.setState({ loading: true, error: '', results: [] });
        try {
            const response = await axios.post(global.config.apiDomain + '/mc-live-room/web/live-room-levels/resolve-live-rooms', { liveRoomUids: tokens });
            if (response.data.status !== 'OK') throw new Error(response.data.message);
            if (sequence !== this.sequence) return [];
            const results = response.data.data.results;
            this.setState({ results, loading: false });
            return results;
        } catch (error) {
            if (sequence === this.sequence) this.setState({ loading: false, error: 'Không tra được phòng. Nhấn Tra lại để thử.' });
            return [];
        }
    };
    change = (input) => {
        ++this.sequence;
        clearTimeout(this.timer);
        this.props.onDraftChange(input);
        this.setState({ input, results: [], error: '', loading: !!input.trim() });
        this.timer = setTimeout(() => this.lookup(input), 300);
    };
    add = async () => {
        clearTimeout(this.timer);
        const input = this.state.input;
        const results = await this.lookup(input);
        if (this.state.input !== input) return;
        const liveRooms = this.props.liveRooms || [];
        const ids = new Set(liveRooms.map(r => r.liveRoomId));
        const added = results.filter(r => r.eligible && r.liveRoom && !ids.has(r.liveRoom.liveRoomId)).map(r => r.liveRoom);
        const unique = Array.from(new Map(added.map(r => [r.liveRoomId, r])).values());
        if (liveRooms.length + unique.length > 100) { this.setState({ error: `Chỉ còn ${100 - liveRooms.length} chỗ trong danh sách.` }); return; }
        this.props.onChange(liveRooms.concat(unique));
        if (results.length && results.every(r => r.eligible)) this.change('');
    };
    render() {
        const { liveRooms = [], disabled, errors = [] } = this.props;
        const { input, results, loading, error } = this.state;
        return <div className="form-group">
            <label>UID phòng hiển thị trên app</label>
            <textarea className="form-control" rows="2" value={input} disabled={disabled}
                placeholder="Nhập hoặc dán nhiều UID, ngăn cách bằng dấu phẩy, khoảng trắng hoặc xuống dòng"
                onChange={e => this.change(e.target.value)} onKeyDown={e => { if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); this.add(); } }} />
            <button type="button" className="btn btn-outline-secondary mt-2" disabled={disabled || loading || !input.trim()} onClick={() => this.lookup(input)}>Tra lại</button>
            <button type="button" className="btn btn-primary mt-2 ml-2" disabled={disabled || loading || !input.trim()} onClick={this.add}>Thêm các phòng hợp lệ</button>
            {loading && <p role="status">Đang tra thông tin phòng...</p>}
            {error && <p className="text-danger" role="alert">{error}</p>}
            {results.map((r, i) => <div key={i} className={r.eligible ? 'text-success' : 'text-danger'}>
                UID {r.input}: {r.liveRoom ? `${r.liveRoom.name || ''} — ${r.liveRoom.status || ''}` : ''} {labels[r.code] || r.code}
                {r.liveRoom && liveRooms.some(liveRoom => liveRoom.liveRoomId === r.liveRoom.liveRoomId) ? ' (Đã thêm)' : ''}
            </div>)}
            <p className="mt-2">Đã chọn {liveRooms.length}/100 phòng</p>
            {liveRooms.map(liveRoom => <div key={liveRoom.liveRoomId} className="border rounded p-2 mb-1 d-flex align-items-center">
                {liveRoom.thumbnail && <img alt="" src={liveRoom.thumbnail} width="36" height="36" className="mr-2" />}
                <span>UID {liveRoom.uid == null ? '(phòng không còn tồn tại)' : liveRoom.uid} — {liveRoom.name || ''} — {liveRoom.status || 'Không tồn tại'}
                    {errors.filter(e => e.liveRoomId === liveRoom.liveRoomId).map(e => <strong key={e.code} className="text-danger ml-2">{labels[e.code] || e.code}</strong>)}
                </span>
                <button type="button" className="btn btn-sm btn-outline-danger ml-auto" disabled={disabled}
                    aria-label="Bỏ phòng khỏi danh sách nhận" onClick={() => this.props.onChange(liveRooms.filter(r => r.liveRoomId !== liveRoom.liveRoomId))}>×</button>
            </div>)}
        </div>;
    }
}
